// extracted by mini-css-extract-plugin
module.exports = {"content":"Payment_content_2kR0T","relative":"Payment_relative_1CVar"};